import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
});

const Previewable = ({
  classes,
  className,
  href,
  iframeStyle,
}) => {
  return (
    <iframe
      className={classNames(classes.root, className)}
      key="facet-file-viewer-iframe"
      width="100%"
      style={iframeStyle}
      title="File Viewer"
      src={href}
    />
  );
};


Previewable.defaultProps = {
  iframeStyle: {},
  className: '',
};


Previewable.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  iframeStyle: PropTypes.object,
  href: PropTypes.string.isRequired,
};

export default withStyles(styles)(Previewable);
